"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableErrorOverlay = void 0;
const react_1 = __importDefault(require("react"));
const table_error_overlay_styles_1 = require("./table-error-overlay.styles");
const TableErrorOverlay = ({ noResultsText }) => (react_1.default.createElement(table_error_overlay_styles_1.StyledTableErrorOverlayContainer, null, react_1.default.createElement(table_error_overlay_styles_1.StyledTableErrorOverlayAlert, { severity: "error" }, noResultsText)));
exports.TableErrorOverlay = TableErrorOverlay;
